// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1o3b-","productName":"Table_productName__1C32C"};